// tslint:disable
/**
 * Document generator api
 * Generate documents from templates
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface Variable
 */
export interface Variable {
    /**
     * 
     * @type {string}
     * @memberof Variable
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Variable
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Variable
     */
    group?: string;
    /**
     * 
     * @type {string}
     * @memberof Variable
     */
    type: VariableTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum VariableTypeEnum {
    StringVariable = 'StringVariable',
    ImageVariable = 'ImageVariable',
    ListVariable = 'ListVariable'
}



